import React, { useState } from "react";
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../../css/Pages.css';

function Collapsible(props) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const klant = props.klant;
    const history = useHistory();
    const abonnementen = klant.abonnementen || [];

    const handleRowClick = () => {
        setIsOpen(!isOpen);
    };

    const handleDetailsClick = (e) => {
        e.stopPropagation();
        history.push("/klant/" + klant.klantId.toString());
    };

    const handleAbonnementClick = (abonnement, e) => {
        e.stopPropagation();
        history.push({
            pathname: "/Abonnementtoevoegen",
            state: { selectedAbonnement: abonnement, klantObject: klant }
        });
    };

    return (
        <>
            <tr className="subscription-row" onClick={handleRowClick} style={{ borderBottom: "1px solid #e5e7eb", borderRight: "1px solid #e5e7eb" }}>
                <td style={{ borderRight: "1px solid #e5e7eb" }}>
                    <span className="subscription-toggle">
                        <span className="subscription-toggle-icon">
                            {isOpen ? '▼' : '▶'}
                        </span>
                        {klant.naam}
                    </span>
                </td>
                <td style={{ borderRight: "1px solid #e5e7eb" }}>{klant.relaNr}</td>
                <td colSpan="2" style={{ textAlign: "center" }}>
                    <button 
                        className="btn btn-secondary" 
                        onClick={handleDetailsClick}
                        style={{ padding: "0.375rem 0.75rem", fontSize: "0.875rem" }}
                    >
                        {t('customers.customerDetails')}
                    </button>
                </td>
            </tr>
            {isOpen && abonnementen.length > 0 && (
                <>
                    <tr className="interface-header-row" style={{ borderRight: "1px solid #d1d5db" }}>
                        <td style={{ fontWeight: "600", borderRight: "1px solid #d1d5db" }}>{t('subscriptions.title')}</td>
                        <td style={{ fontWeight: "600", borderRight: "1px solid #d1d5db" }}>{t('subscriptions.startDate')}</td>
                        <td style={{ fontWeight: "600", borderRight: "1px solid #d1d5db" }}>{t('subscriptions.endDate')}</td>
                        <td style={{ fontWeight: "600" }}>{t('subscriptions.status')}</td>
                    </tr>
                    {abonnementen.map(abonnement => (
                        <tr
                            key={abonnement.abonnementId}
                            className="interface-row"
                            onClick={(e) => handleAbonnementClick(abonnement, e)}
                            style={{ borderBottom: "1px solid #e5e7eb" }}
                        >
                            <td style={{ borderRight: "1px solid #e5e7eb" }}>{abonnement.abonnementType.naam}</td>
                            <td style={{ borderRight: "1px solid #e5e7eb" }}>
                                {abonnement.startdatum
                                    ? abonnement.startdatum.toString().split("T")[0]
                                    : "-"}
                            </td>
                            <td style={{ borderRight: "1px solid #e5e7eb" }}>
                                {abonnement.einddatum
                                    ? abonnement.einddatum.toString().split("T")[0]
                                    : "-"}
                            </td>
                            <td>{abonnement.status}</td>
                        </tr>
                    ))}
                </>
            )}
            {isOpen && abonnementen.length === 0 && (
                <tr className="empty-row" style={{ borderRight: "1px solid #e5e7eb" }}>
                    <td colSpan="4">{t('subscriptions.noSubscriptions')}</td>
                </tr>
            )}
        </>
    );
}

export default Collapsible;